(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cl-goto]');
      if (!button) return;
      const list = button.closest('[data-cl-list]');
      const page = button.dataset.clGoto;
      list.querySelectorAll('[data-cl-page]').forEach((item) => {
        item.hidden = item.dataset.clPage !== page;
      });
      list.querySelectorAll('[data-cl-goto]').forEach((other) => {
        const active = other === button;
        other.classList.toggle('is-active', active);
        if (active) other.setAttribute('aria-current', 'page');
        else other.removeAttribute('aria-current');
      });
      list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-sticky-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    window.mcScroller =
      window.mcScroller ||
      (() => {
        const wrapper = document.querySelector('.page-wrapper');
        if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY)) return wrapper;
        return document.scrollingElement || document.documentElement;
      });
    window.mcScrollToElement =
      window.mcScrollToElement ||
      ((element, offset) => {
        const scroller = window.mcScroller();
        const isRoot = scroller === document.scrollingElement || scroller === document.documentElement;
        const base = isRoot ? 0 : scroller.getBoundingClientRect().top;
        const top = element.getBoundingClientRect().top - base + scroller.scrollTop - (offset || 0);
        scroller.scrollTo({ top, behavior: 'smooth' });
      });
  })();
  if (!customElements.get('mc-sticky-tabs')) {
    class McStickyTabs extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('[data-mc-tab]')];
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        };
        this.onClick = (event) => {
          const link = event.target.closest('[data-mc-tab]');
          if (!link || !link.mcTarget) return;
          event.preventDefault();
          window.mcScrollToElement(link.mcTarget, this.headerOffset() + this.offsetHeight - 1);
        };
        this.addEventListener('click', this.onClick);
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        window.addEventListener('resize', this.onScroll);
        this.findTargets();
        this.update();
        setTimeout(() => {
          this.findTargets();
          this.update();
        }, 1500);
      }
      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
      }
      isShown(element) {
        return !!element && element.getClientRects().length > 0;
      }
      findTargets() {
        this.links.forEach((link) => {
          let target = null;
          try {
            target = document.querySelector(link.dataset.mcTab);
          } catch (error) {
            target = null;
          }
          if (target && link.dataset.mcTab === '[data-mc-reviews]') target = target.closest('.shopify-section') || target;
          link.mcTarget = this.isShown(target) ? target : null;
          link.hidden = !link.mcTarget;
        });
        this.active = this.links.filter((link) => link.mcTarget);
      }
      headerOffset() {
        const header = document.querySelector('#header-component');
        if (!header) return 0;
        const rect = header.getBoundingClientRect();
        return rect.bottom > 0 && rect.top > -2 ? rect.bottom : 0;
      }
      update() {
        const offset = this.headerOffset();
        this.style.top = `${offset}px`;
        let show = false;
        if (this.active.length > 0) {
          let trigger = null;
          try {
            trigger = this.dataset.trigger ? document.querySelector(this.dataset.trigger) : null;
          } catch (error) {
            trigger = null;
          }
          show = trigger ? trigger.getBoundingClientRect().bottom < offset : window.mcScroller().scrollTop > 400;
        }
        this.classList.toggle('mc-tabs--visible', show);
        const line = offset + this.offsetHeight + 8;
        let current = null;
        this.active.forEach((link) => {
          if (link.mcTarget.getBoundingClientRect().top <= line) current = link;
        });
        this.active.forEach((link) => link.setAttribute('aria-current', link === current ? 'true' : 'false'));
      }
    }
    customElements.define('mc-sticky-tabs', McStickyTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["museum-drawer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('museum-drawer')) {
  customElements.define(
    'museum-drawer',
    class MuseumDrawer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-mdr-dialog]');
        if (!this.dialog) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-museum-drawer-open]');
          if (!trigger) return;
          event.preventDefault();
          this.lastTrigger = trigger;
          this.open();
        }, { signal });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('[data-mdr-close]')) {
            this.close();
            return;
          }
          const toggle = event.target.closest('[data-mdr-toggle]');
          if (toggle) this.togglePanel(toggle.closest('[data-mdr-panel]'));
        }, { signal });
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        }, { signal });
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.open();
        }, { signal });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.close();
        }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          if (event.detail && event.detail.sectionId === this.dataset.sectionId) {
            this.open();
            const panel = event.target.closest && event.target.closest('[data-mdr-panel]');
            if (panel && panel.classList.contains('mdr-panel--expandable') && !panel.classList.contains('is-open')) this.togglePanel(panel);
          }
        }, { signal });
      }
      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        document.documentElement.style.removeProperty('overflow');
      }
      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        document.querySelectorAll('[data-museum-drawer-open]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
        requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
      }
      close() {
        if (!this.dialog.open) return;
        this.dialog.classList.remove('is-open');
        document.querySelectorAll('[data-museum-drawer-open]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
        const finish = () => {
          this.dialog.close();
          document.documentElement.style.removeProperty('overflow');
          if (this.lastTrigger && document.contains(this.lastTrigger)) this.lastTrigger.focus();
        };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          finish();
          return;
        }
        this.dialog.addEventListener('transitionend', finish, { once: true });
        setTimeout(() => {
          if (this.dialog.open && !this.dialog.classList.contains('is-open')) finish();
        }, 450);
      }
      togglePanel(panel) {
        if (!panel || !panel.classList.contains('mdr-panel--expandable')) return;
        const willOpen = !panel.classList.contains('is-open');
        this.querySelectorAll('[data-mdr-panel].is-open').forEach((other) => {
          if (other !== panel) {
            other.classList.remove('is-open');
            const t = other.querySelector('[data-mdr-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        panel.classList.toggle('is-open', willOpen);
        const toggle = panel.querySelector('[data-mdr-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', String(willOpen));
        if (willOpen) panel.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
